import React from 'react';
import { ExclamationCircleIcon } from '@heroicons/react/outline';
import { parseMarkdown } from '../../lib/markdown';
import { ProgramActivityStatus } from '../ProgramActivityStatus';
import VerticalSignatureDisplay from './VerticalSignatureDisplay';
import {
  ProgramActivityDataFragment,
  UserType,
} from '../../../generated/graphql';

interface CardContentProps {
  isSmallStyle: boolean;
  showHoverWarning: boolean;
  signatureWarningMessage: string;
  title: string;
  providerNote: string;
  programActivity: ProgramActivityDataFragment;
  userType: UserType;
  authedProviderUserId?: string;
}

export const CardContent: React.FC<CardContentProps> = ({
  isSmallStyle,
  showHoverWarning,
  signatureWarningMessage,
  title,
  providerNote,
  programActivity,
  userType,
  authedProviderUserId,
}) => {
  if (isSmallStyle) {
    return (
      <div className="flex w-full flex-row items-center justify-between">
        <div className="flex flex-col items-start justify-center">
          {showHoverWarning ? (
            <div className="grow break-words pr-5 text-small-caption text-neutral-125">
              {signatureWarningMessage}
            </div>
          ) : (
            <>
              <div className="grow break-words text-caption font-medium text-neutral-150 line-clamp-2">
                {title}
              </div>
              {providerNote && (
                <div
                  className="prose prose-sm max-w-none whitespace-pre-wrap break-words text-caption text-neutral-125 line-clamp-1"
                  dangerouslySetInnerHTML={{
                    __html: parseMarkdown(providerNote),
                  }}
                />
              )}
            </>
          )}
        </div>
        {showHoverWarning && (
          <div className="relative">
            <ExclamationCircleIcon className="h-5 min-h-[20px] w-5 min-w-[20px] text-orange-100" />
          </div>
        )}
      </div>
    );
  }

  return (
    <div className="flex w-full items-center justify-between">
      <div className="flex min-w-0 flex-1 flex-col">
        <div className="text-caption font-medium text-neutral-150 line-clamp-2">
          {title}
        </div>
        <VerticalSignatureDisplay
          programActivity={programActivity}
          className="mt-1"
          context="mail"
          authedProviderUserId={authedProviderUserId}
          userType={userType}
        />
      </div>
      <ProgramActivityStatus
        programActivity={programActivity}
        className="ml-4 flex-none"
        userType={userType}
      />
    </div>
  );
};
